import { render, staticRenderFns } from "./DFRReport.vue?vue&type=template&id=748fb290&scoped=true"
import script from "./DFRReport.vue?vue&type=script&lang=js"
export * from "./DFRReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fb290",
  null
  
)

export default component.exports